import { ReactNode } from 'react';

interface ModuleCardProps {
  title: string;
  titleEn?: string;
  subtitle?: string;
  /** Kept for backward compatibility with stored module data; no longer rendered. */
  icon?: string;
  headerStyle?: string;
  headerColor?: string;
  children: ReactNode;
}

/** A titled section inside a wizard step. */
export default function ModuleCard({ title, subtitle, children }: ModuleCardProps) {
  return (
    <section className="flex flex-col gap-4">
      <div className="flex flex-col gap-0.5 leading-snug">
        <h2 className="text-[17px] font-black">{title}</h2>
        {subtitle && <p className="text-[13px] text-muted">{subtitle}</p>}
      </div>
      <div className="flex flex-col gap-4">{children}</div>
    </section>
  );
}
